export default {
    lang: {
        name: 'Community votes'
    }
}